module.exports = __webpack_public_path__ + "img/home_tshaypeng.edebfcd0.png";